import styled from 'styled-components'

import { spacing } from '../../../utils/ui/spacing'

export const Wrapper = styled.ul`
  display: flex;
  width: auto;
  justify-content: center;
  align-items: center;
  background: none;
  height: ${spacing('md')};
  padding: 2px;
  position: relative;
  bottom: -${spacing('lg')};
`

export const DotWrapper = styled.li`
  padding: 0 ${spacing('xs')};
`

type DotProps = { isActive: boolean }

export const Dot = styled.div<DotProps>`
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.tokens.interface.neutral.strong};
  opacity: ${({ isActive }) => (isActive ? 1 : 0.16)};
  cursor: pointer;
  transition: background-color 0.15s cubic-bezier(0.4, 0, 1, 1);
`
